var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBigDataChurn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#big-data-churn_svg__clip0)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.433 19.275l1.838 1.062-1.967-7.585-7.552 2.088 1.838 1.062L.5 22.985l3.354 5.81H13.91v-6.747H8.833l1.6-2.773zm-3.525-3.638l2.06-.57.536 2.068-2.837 4.913h-3.46l3.701-6.411zm5.126 8.286v2.997H4.937l-1.73-2.997h8.827zM18.1 11.54l-1.838 1.06 7.552 2.089 1.968-7.585-1.838 1.062-4.09-7.083h-6.708L8.119 9.79l5.842 3.373L16.5 8.767l1.6 2.773zm4.914-1.234l-.536 2.068-2.06-.57-2.835-4.912 1.73-2.997 3.701 6.411zm-9.739.296L10.68 9.104l3.548-6.146h3.461l-4.414 7.644zM27.473 14.277l-5.843 3.374 2.538 4.396h-3.201v-2.123l-5.585 5.497 5.585 5.496v-2.123h8.179l3.354-5.81-5.027-8.707zM19.578 26.92l-1.523-1.498 1.523-1.499h5.672l1.73 2.997h-7.402zm9.027-.937l-4.414-7.645 2.595-1.498 3.55 6.146-1.731 2.997z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "big-data-churn_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgBigDataChurn;